<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="info">添加</Button>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' show-elevator />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Html',
		data() {
			return {
				data: [
					{
						title:'郭晓强',
						label:'2025-02-14',
					},
					{
						title:'郭晓强',
						label:'2025-02-14',
					},{
						title:'郭晓强',
						label:'2025-02-14',
					}
				],
				columns:[
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title:'文档标题',
						minWidth:200,
						align:'left',
						key:'title'
					},
					{
						title:'标签',
						minWidth:200,
						align:'left',
						key:'label'
					},
					{
						title:'操作',
						minWidth:200,
						align:'center',
						render:(h,param)=>{
							return h('div',[
								h('Button',{
									props:{
										type:'primary',
										size:'small'
									},
									style:{
										marginRight:'6px'
									},
									on:{
										'click':function(){
											
										}
									}
								},'编辑'),
								h('Button',{
									props:{
										type:'error',
										size:'small'
									},
									style:{
										
									},
									on:{
										'click':function(){
											
										}
									}
								},'删除')
							])
						}
					}
				],
				total: 0,
				page: 1
			}
		},
		methods:{
			doEdit(){
				
			},
			doDelete(){
				
			}
		},
		mounted(){
			let obj = {
				title:'郭晓强',
				label:'2025-02-14',
			};
			
			let arr = [];
			for(let i = 0; i < 10; i++){
				arr.push(obj);
			}
			
			this.data = arr;
		}
	}
</script>

<style scoped>
	.ivu-layout{
		height: 100vh !important;
	}
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
	}
	.ivu-divider-horizontal{
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/child/Html.vue